import { render, staticRenderFns } from "./FormRecover.vue?vue&type=template&id=176662f8&"
import script from "./FormRecover.vue?vue&type=script&lang=js&"
export * from "./FormRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports